import { render, staticRenderFns } from "./CompactSalesFlashTable.vue?vue&type=template&id=15617fb6&scoped=true&"
import script from "./CompactSalesFlashTable.vue?vue&type=script&lang=js&"
export * from "./CompactSalesFlashTable.vue?vue&type=script&lang=js&"
import style0 from "./CompactSalesFlashTable.vue?vue&type=style&index=0&id=15617fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15617fb6",
  null
  
)

export default component.exports